<template>
    <div>
        <div class="nav-bar">
            <div class="meun-btn change" role="button"
                :class="{'is-open': isMenuOpened}"
                @click="toggleMenu">
                <div class="hamberger">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>

            <div class="cart-btn" role="button"
                :style="{
                    display: hasCartItems ? 'block' : 'none',
                }"
                :class="{'is-open': isMenuOpened}">
                <a @click.prevent="showCartList">
                    <span class="cart-number">{{ getCartCount() }}</span>
                    <div class="cart-icon"></div>
                </a>
            </div>
        </div>

        <div class="Menu-layer" :class="{'is-open': isMenuOpened}">
            <div class="wrapper">
                <div class="meun-inner" :class="{'is-open': isMenuOpened}">
                    <div class="login-btn" role="button">
                        <a :href="globalStore.getRoute('hc.member.index')"><span>會員中心</span></a>
                    </div>
                    <ul class="ul-width">
                        <li class="item"><a href="">產品購買</a></li>
                        <div class="P-item">
                            <ul>
                                <li><a :href="globalStore.getRoute('hc.product.buy', {product: 'probiotic'})" role="button" >好聰敏3益生菌</a></li>
                                <li><a :href="globalStore.getRoute('hc.product.buy', {product: 's-probiotic'})" role="button" >好聰敏S消化菌</a></li>
                                <li><a :href="globalStore.getRoute('hc.product.buy', {product: 'gutarget'})" role="button" >好清便順暢菌</a></li>
                                <li><a :href="globalStore.getRoute('hc.product.buy', {product: 'collagenplusc'})" role="button" >肽媄儷膠原C<sup>++</sup></a></li>
                                <li><a role="button" :href="globalStore.getRoute('hc.product.index') + '#selection-layer'">
                                    <img class="go-position" :src="globalStore.getAsset('images/index/sharybuy-btn.webp')" alt="員購共享購">
                                </a></li>
                                <div class="clearFloat"></div>
                            </ul>
                        </div>
                    </ul>
                    <ul class="ul-width">
                        <li class="item"><a role="button" :href="globalStore.getRoute('hc.product.index')">產品介紹</a></li>
                        <li class="item"><a role="button" :href="globalStore.getRoute('hc.event.share.index')">心得分享</a></li>
                        <li class="item"><a role="button" :href="globalStore.getRoute('hc.document')">產品履歷</a></li>
                        <li class="item"><a role="button" :href="globalStore.getRoute('hc.faq.knowledge.index')">衛教專欄</a></li>
                        <li class="item"><a role="button" :href="globalStore.getRoute('hc.faq.index')">常見問題</a></li>
                        <div class="clearFloat"></div>
                    </ul>

                </div>
            </div>
        </div>

        <div class="shop-bag-list-bg"
            :class="{'show': isCartListOpened}">

            <div class="shop-bag-list">
                <div class="top shop-close-btn" role="button" @click="showCartList">
                    <p>購物清單</p>
                </div>
                <div class="content">
                    <ul class="shop-list" v-if="hasCartItems">
                        <template v-for="(item, ik) in cart.list" :key="ik">
                            <li class="shop-list__item" v-if="!item?.options?.no_act">
                                <div class="grid-3">
                                    <div>
                                        <img :alt="item.name" :src="item?.options?.cover" />
                                        <img class="teste-icon" alt=""
                                            :src="item.options.favor_icon"
                                            v-if="item?.options?.favor_icon" />
                                    </div>
                                    <div>
                                        <p class="name" v-html="item.name"></p>
                                        <p :class="`taste ${item?.options?.flavor_css}`"
                                            v-if="item?.options?.flavor">
                                            <span v-html="item.options.flavor"></span>
                                        </p>
                                        <div class="taste spot-goods" v-if="item?.options?.expiry">超值價</div>
                                        <template v-for="exp in getCartItemExpData(item)" :key="exp.id">
                                            <div v-if="!exp.is_ignore">
                                                <span>{{ exp.name }}</span>
                                                <span>x</span>
                                                <span>{{ exp.boxes }}</span>
                                            </div>
                                        </template>
                                        <template v-if="item?.options?.gifts">
                                            <div class="gift" v-for="(g, gk) in item.options.gifts" :key="gk">
                                                <span><strong sv-html="g.title"></strong> * <label sv-html="g.qty"></label></span>
                                            </div>
                                        </template>
                                    </div>
                                    <div class="delet-btn" role="button" @click="removeItem(item)"></div>
                                </div>
                                <div class="three-btn-box">
                                    <div class="box">
                                        <a class="minus-btn" @click.prevent="setQty(item, '-')"></a>
                                        <a class="prduct-num y1" style="color: dark!important;">{{ item.qty }}</a>
                                        <a class="plus-btn" @click.prevent="setQty(item, '+')"></a>
                                    </div>
                                    <div class="total-money">{{ toNumeric(item.subtotal) }}</div>
                                </div>
                            </li>
                        </template>
                    </ul>
                </div>
                <div class="all-money">
                    <span>金額小計</span>
                    <span class="number">{{ toNumeric(cart?.total ?? 0) }}</span>
                </div>
                <a role="button" class="goto-car-btn" :href="gotoCartPage">前往結帳</a>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import { toNumeric } from '@hc/composables/utils';
import { fetchAPI } from '@hc/composables/fetch';
import { useGlobalStore } from '@hc/stores/useGlobalStore';
//
//import ProgressSpinner from 'primevue/progressspinner';
//

const globalStore = useGlobalStore();
const { global, cart, loading } = storeToRefs(globalStore);
const { fetchData } = fetchAPI();

const props = defineProps({
    asset: {
        type: String,
        required: false,
        default: '',
    },
    global: {
        type: Object,
        required: true,
        default: () => ({}),
    },
});

const isMenuOpened = ref(false);
const isCartListOpened = ref(false);

//Computed
// 購物車是否有商品
const hasCartItems = computed(() => cart?.value?.count > 0);
const gotoCartPage = computed(() => route('hc.cart.index'));
//Method
// 切換網站選單
const toggleMenu = () => {
    isMenuOpened.value = !isMenuOpened.value;
    document.body.classList.toggle('is-open', isMenuOpened.value);
};
// 顯示購物車清單
const showCartList = () => {
    // if (!hasCartItems.value) {
    //     return;
    // }
    const url = new URL(window.location.href);
    if (url?.pathname && url?.pathname.includes('cart')) {
        return;
    }
    isCartListOpened.value = !isCartListOpened.value;
    document.body.classList.toggle('is-open', isCartListOpened.value);
};
// 更新購物車數量
const setQty = (item, type) => {
    if (!item?.qty || !item?.rowId) {
        return;
    }
    let qty = Number.parseInt(item.qty, 10);
    switch (type) {
        case '-':
            if (qty - 1 < 1) {
                return;
            }
            qty -= 1;
            break;
        case '+':
            qty += 1;
            break;
    }
    globalStore.setCartQty(item.rowId, qty);
};
// 刪除購物車商品
const removeItem = (item) => {
    if (!item?.rowId) {
        return;
    }
    globalStore.removeCartItem(item.rowId);
};

const getCartCount = () => {
    let count = 0;
    if (!cart.value?.list) {
        return '';
    }
    //略過options.no_act的商品
    Object.keys(cart.value.list).filter(k => {
        const item = cart.value.list[k];
        if (item?.options?.no_act) {
            return;
        }
        count++;
    });
    return count > 0 ? count : '';
};
const getCartItemExpData = (item) => {
    const expdata = item?.options?.exp_data;
    const ignore = item.id.toString().startsWith('95014002');
    if (!expdata) {
        return [];
    }
    try {
        let data = JSON.parse(expdata);
        if (data) {
            data = data.map(vo => {
                return {...vo, is_ignore: ignore};
            });
        }
        return data;
    } catch (error) {
        console.error(error);
    }
};

onMounted(async() => {
    //
    globalStore.setProps({
        asset: props.asset,
        global: props.global,
    });
    await globalStore.fetchCart();
});
</script>
